import React from 'react';
import PropTypes from 'prop-types';
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  IonButton,
  IonText,
} from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';
import { useHistory } from 'react-router';

function PaymentErrorModal({ isOpen, setShowAlert }) {
  const history = useHistory();

  const onContinueAction = () => {
    setShowAlert(false);
    history.push('/payment-methods')
  }

  return (
    <IonModal isOpen={isOpen} className="custom-payment-alert">
      <IonContent>
        <IonList>
          <IonItem lines="none" className="mt-2x">
            <div className="d-flex-content d-flex-center">
              <IonIcon
                className="loyalty-close-icon"
                icon={closeCircleOutline}
              />
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <h3>Your card was declined</h3>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <p className="custom-alert-message">We tried to preauthorize your card but it got declined.</p>
              </IonLabel>

              <IonLabel className="ion-text-wrap mt-2x">
                <p className="custom-alert-message">Please select or add another</p>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mt-5x">
            <div className="d-flex-row-center">
              <IonButton
                color="tertiary"
                expand="block"
                fill="solid"
                type="button"
                className="loyalty-button-wrap"
                onClick={onContinueAction}
              >
                <IonText color="light"><p className="loyalty-button-size">Continue</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

PaymentErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  setShowAlert: PropTypes.func,
};

export default PaymentErrorModal;
